import apiClient from './apiClient';
import { GET_USER_INFO_URL } from './apiUrl';

const getUserInfoApi = () => {
  return apiClient.get(GET_USER_INFO_URL);
};

export default getUserInfoApi;
